// i18n.js 多语言
import {createI18n} from 'vue-i18n';
import zh from './zh-cn.js';
import en from './en.js';
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import enEn from 'element-plus/dist/locale/en.min.mjs'

const messages = {
    zh: {
        ...zh,
        ...zhCn,
    },
    en: {
        ...en,
        ...enEn,
    },
};

const i18n = createI18n({
    locale: 'zh',
    fallbackLocale: 'zh',
    messages,
});

export default i18n;